import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import '@/icons'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/global'
import '@/permission'
import '@/filters'
import Router from 'vue-router';

import {} from '@/utils/btnPriv'
import '../static/css/common.css'
import '../static/icon/fonts.css'
import '../static/icon/iconfont.css'

// VueAxios
import VueAxios from 'vue-axios';
import axios from 'axios';
Vue.prototype.$http = axios
axios.defaults.withCredentials = true;
Vue.use(VueAxios, axios);

// echarts
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

// vxe-table
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)
Vue.prototype.$modal = VXETable.modal

// Highcharts
import Highcharts from 'highcharts/highstock';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import Highmaps from 'highcharts/modules/map';

HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
Highmaps(Highcharts);

Vue.prototype.$Highcharts = Highcharts;

import download from '@/utils/downloadFile'
Vue.prototype.$download = download;

// import Print from './js/print.js'
import Print from 'vue-print-nb'
Vue.use(Print)

// 全局组件
import MySelect from "@/components/MySelect";
import StatisticsTemp from "@/components/StatisticsTemp";
import wps from "@/components/office/wps.vue";
import AngleMark from "@/components/AngleMark.vue";

Vue.component("MySelect", MySelect);
Vue.component("StatisticsTemp", StatisticsTemp);
Vue.component("wps", wps);
Vue.component("AngleMark", AngleMark);

Vue.use(Router);
Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js